module.exports = __webpack_public_path__ + "static/img/donuts.5d6e951.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/donuts.gif
// module id = 5O3Q
// module chunks = 4